import { StreamingPlayerError } from '@heardis/stream-contracts';

export enum AnalyticsEventType {
  LINK_TO_SPOTIFY = 'hdis_link_to_spotify',
  TRACK_PLAY = 'hdis_track_play',
  TRACK_PAUSE = 'hdis_track_pause',
  TRACK_SEEK = 'hdis_track_seek',
  GO_TO_NEXT_TRACK = 'hdis_go_to_next_track',
  GO_TO_PREVIOUS_TRACK = 'hdis_go_to_previous_track',
  GO_TO_TRACK = 'hdis_go_to_track',
  SHOW_DESCRIPTION = 'hdis_show_description',
  SHOW_TRACKLIST = 'hdis_show_tracklist',
  SHOW_NOTES = 'hdis_show_notes',
  PLAYER_ERROR = 'hdis_player_error',
  PAGE_RELOAD = 'hdis_page_reload',
  USER_LOGIN = 'hdis_user_login',
  USER_LOGOUT = 'hdis_user_logout',
}

export type AnalyticsEventAction =
| { type: AnalyticsEventType.LINK_TO_SPOTIFY; track_id: string } // Should we also include the spotify ID here?
| { type: AnalyticsEventType.TRACK_PLAY; track_id_current: string }
| { type: AnalyticsEventType.TRACK_PAUSE; track_id_current: string }
| { type: AnalyticsEventType.TRACK_SEEK; track_id_current: string }
| { type: AnalyticsEventType.GO_TO_NEXT_TRACK; track_id_current: string; track_id_target: string }
| { type: AnalyticsEventType.GO_TO_PREVIOUS_TRACK; track_id_current: string; track_id_target: string }
| { type: AnalyticsEventType.GO_TO_TRACK; track_id_current: string; track_id_target: string }
| { type: AnalyticsEventType.SHOW_DESCRIPTION }
| { type: AnalyticsEventType.SHOW_TRACKLIST }
| { type: AnalyticsEventType.SHOW_NOTES; track_id?: string }
| { type: AnalyticsEventType.PLAYER_ERROR; error: StreamingPlayerError }
| { type: AnalyticsEventType.PAGE_RELOAD }
| { type: AnalyticsEventType.USER_LOGIN; username: string }
| { type: AnalyticsEventType.USER_LOGOUT; username: string };
